import React from 'react';
import { connect } from 'react-redux';
//import 'antd/dist/antd.css';
import { Collapse } from 'antd';
import { Checkbox } from 'antd';
import { LoadingComponent } from '../../utils/ui'
import { AdmsRepository } from '../../redux/AdmsActions';
import { subsetByLang, subsetByLangOrEmpty } from '../../virtuoso/helper';
import ConceptCount from '../widgets/ConceptCount';
const Panel = Collapse.Panel;

function callback(key) {
  console.log(key);
}

/** Сортирует концепты по вложенности. Идёт концепт без вложенности, затем все вложенные в него и т.д 
 * получаем концепты с наименованиями, уровнем, с флагом наличия вложения. */
function contentToConcepts(content,lang){
  const concepts = subsetByLangOrEmpty(content.concepts, lang, "IRI", "Label")
  concepts.forEach(concept => {
    concept["level"] = 0;
    concept["hasBroader"] = false;
    concept["children"] = [];
    concept["statistic"] = 0;
  } );
  let temp = concepts.reduce((result, item) => {
      result[item.IRI.value] = item;
      return result;
  }, {});
  //Сделаем сортировку по значению идентификатора
  if (content.identifier){
    concepts.forEach((concept, index) => {
      concept["identifier"] = concept.IRI.value? content.identifier[concept.IRI.value]: index;
    })
    concepts.sort((a,b) => {
        return a.identifier - b.identifier;
      });
  };
  //Сделаем связь и уровень по значению broader
  if (content.broader){
    //Будем бегать в цикле, пока произодит изменения индекса уровня
    let hasLevelChanged = true; let countIndex = 0;
    while (hasLevelChanged){
      hasLevelChanged = false;
      concepts.forEach(concept => {
        //Должно быть отличие соседних уровней на 1.
        if (content.broader[concept.IRI.value]){
          concept["broader"] = content.broader[concept.IRI.value];
          temp[concept["broader"]].hasBroader = true;
          if (!temp[concept["broader"]].children.includes(concept))
            temp[concept["broader"]].children.push(concept);
          if (temp[concept.IRI.value].level != temp[concept["broader"]].level+1){
            hasLevelChanged = true;
            temp[concept.IRI.value].level = temp[concept["broader"]].level+1;
          }
        }
      })
        countIndex++;
      if (countIndex>1000) {
        console.warn("ConceptScheme.js too long while level changed!!! countIndex is ", countIndex);
        break;
      }
    }
  };
  //console.log("ConceptScheme.js function contentToConcepts(content,lang) 2", concepts, lang)
  return concepts;
}

/** Формирует список концептов для отображения (с учётом иерархии концептов).
 * Если вложеный концепт отображется, то должна отображаться вся цепочка до уровня 0
 * 
 * Если hasCollapsed = true, то нужно создать список элементов, которые должны сворачиваться. Для этого дочерние элементы 
 * добавляеются в свойство children
*/
function conceptsForShow(concepts, loading, statistics, hasCollapsed=false){
  //Флаг пустой или нулевой статистики - для показа всего списка концептов
  const emptyStatistics = loading || Object.keys(statistics).length ==0 || Object.keys(statistics).filter(key =>
    statistics[key] == 0
    ).length == Object.keys(statistics).length;  
  if (emptyStatistics) 
    return hasCollapsed? makeCollapseTree(concepts): concepts;
  const filteredConcepts = concepts.filter(
      concept => hasChildrenStatistics(concept, statistics, (concept.children)?concept.children.length>0:false, concepts)
    );
    return hasCollapsed? makeCollapseTree(filteredConcepts): filteredConcepts;
}
/**Проверяет наличие статистики во вложенных элементах */
function hasChildrenStatistics(concept, statistics, checkChildrenStatistic, concepts){
  return !statistics.hasOwnProperty(concept.IRI.value) 
    || (statistics.hasOwnProperty(concept.IRI.value) && statistics[concept.IRI.value]!=0) 
    || (checkChildrenStatistic && concept.children.filter(
        child => hasChildrenStatistics(child, statistics, (child.children)?child.children.length>0: false, concepts)).length>0
      );
}

/** Формирует дерево из элементов, которые должны сворачиваться. В качестве основе используется сначение children в списке */
function makeCollapseTree (concepts) {
  let temp = concepts.reduce((result, item) => {
      result[item.IRI.value] = item;
      return result;
  }, {});
  return concepts.map(
      concept => Object.assign({...concept}, {"collapse": concept.children.filter(chid => temp[chid.IRI.value])})
    ).filter(
      concept => concept.level == 0
    );
}

/** Сформировать условия для отбора или снятия отбора  */
function makeConceptCondition (concept, schemeIRI) {
  return {
    predicate: "http://www.w3.org/ns/dcat#theme", 
    operator: "=", 
    value: concept.IRI.value, 
    alias:"theme", 
    label:concept.Label.value,
    type: "uri",
    scheme: schemeIRI
  };
};

const CollapseGroup = (view, root, concepts, selected, hasCheck, onChangeConcept= f=>f, expand, hideStatistics=false) => {
  const isRootChecked = hasChecked(view, root, selected, hasCheck);
  //style={{"marginBlockEnd": "0em", "paddingRight": "0px"}} 
  return (
    <Collapse defaultActiveKey={expand?['1']:[]} onChange={callback}>
      <Panel key="1" header={
        <div onClick={e => e.stopPropagation()}>
          <Checkbox checked={isRootChecked} onChange={(e) => onChangeConcept(e, root, concepts)}>
            {root.Label.value}&nbsp;{!hideStatistics &&<ConceptCount IRI={root.IRI.value} concept={root} waitStatistics />}
          </Checkbox>
        </div>
      }>
        {concepts.map((concept, i)=> {
            const isChecked = hasChecked(view, concept, selected, hasCheck);
            //console.log("concepts.map((concept, i)",isChecked, concept);
            return (
              <div key={concept.IRI.value} style={{"marginBottom": "1rem"}}>
                { (Array.isArray(concept.collapse) && concept.collapse.length>0) ?
                  CollapseGroup (view, concept.collapse, selected, hasCheck, onChangeConcept, expand, hideStatistics) 
                : 
                  <Checkbox checked={isChecked} onChange={(e) => onChangeConcept(e, concept)}>
                    {concept.Label.value}&nbsp;{!hideStatistics &&<ConceptCount IRI={concept.IRI.value} waitStatistics />}
                  </Checkbox>
                }
              </div>
            )
          })
        }
      </Panel>
    </Collapse>
  )
}

/**
 * Проверка на установку галки в чекбоксе
 */
const hasChecked = (view, concept, selected, hasCheck=undefined) =>{
  //console.log("ConceptScheme.js hasChecked", view, concept, selected, hasCheck);
  if (view =='single' && hasCheck){
    return hasCheck.filter(item => item.iri ==concept.IRI.value).length>0;
  }
  return (selected)? selected.filter(
    item => (Array.isArray(item.value)?item.value.indexOf(concept.IRI.value)>=0:item.value==concept.IRI.value)
  ).length>0: false;  
}
/** Отображение схемы концептов (ConceptScheme в SKOS). Схема концептов определяется по IRI. 
 * 
 * Виды отображения (view) могут иметь следующие значения
 * 1. null или undefined - используется для задания условий отбора
 * 2. single - выбор одного значения (у остальных галки сбрасываются)
 * 
 * Для схемы:
 * 1. загружается имя схемы
 * 2. загружается состав концептов (концепты, которые имеют свойство http://www.w3.org/2004/02/skos/core#inScheme)
 * 3. загружается количество концептов 
 *    если флаг установле hideStatistics, статистика не загружается и не показывается
 * 
*/
class ConceptScheme extends React.Component {	

  state = {
    loading: false, 	  //Флаг загрузки
    statistics:{},      //Статистика по количеству связанных концептов по результатам отбора. 
                        //Заполняется в результате назначений условий отбрра
  };

  /** Вызывается сразу после монтирования компонента (вставки в дерево).  
  * см. https://legacy.reactjs.org/docs/react-component.html#componentdidmount */
  componentDidMount() {
    if (this.props.IRI) 
      this.loadTaxonomy();
  };

  /** Вызывается сразу после обновления. Этот метод не вызывается для первоначального рендеринга. 
   * см. https://legacy.reactjs.org/docs/react-component.html#componentdidupdate */
  componentDidUpdate(prevProps) {
    const {content} = this.props;
    if ((content==undefined)||(content.state==undefined)||content.state=="empty" || this.props.IRI != prevProps.IRI)
      this.loadTaxonomy(this.props.IRI != prevProps.IRI);
  };
  
  loadTaxonomy(reload= false) {
    //console.log(this, "onLoadTaxonomy", this.props.IRI);
    if (!reload && this.state.loading)
      return;
    this.setState({loading: true});
    const {IRI} = this.props;
    if (IRI)
      this.props.onLoadTaxonomy(IRI)
        .then ((response) =>{
          this.setState({loading: false})
          if (!this.props.hideStatistics)
            this.loadTaxonomyStatistics();
        })
        .catch(e => { 
          this.setState({loading: false})
        });
  };
    
  /** Подготовить статистику к отображению */
  loadTaxonomyStatistics() {
    const {content, lang,graph, rfilter, statistics} = this.props;
    const concepts = (content && content.concepts)? content.concepts:[];
    const showStatistics = {}; 
    //console.log("ConceptScheme.js loadTaxonomyStatistics()", this, concepts);
    concepts.forEach(concept =>{
      if (typeof statistics[concept.IRI.value] === 'undefined')
        showStatistics[concept.IRI.value] = 0;
      else
        showStatistics[concept.IRI.value] = statistics[concept.IRI.value].count;
    });
    this.setState({statistics: showStatistics});
  }
 
  onChangeConcept(e, concept, children = undefined) {
    e.preventDefault();
    //console.log(`checked = ${e.target.checked}`, e, concept, this);
    const {onChange, IRI, selected, view} = this.props;
    if (view == 'single'){
      //console.log("ConceptScheme.js onChangeConcept", concept, children);
      if (onChange) 
        onChange(e.target.checked, concept);
      return;
    };
    const condition = makeConceptCondition(concept, IRI);
    if (children){
      const isChecked = (selected)? selected.filter(
          item => (Array.isArray(item.value)?item.value.indexOf(concept.IRI.value)>=0:item.value==concept.IRI.value)
        ).length>0: false;
      const conditions = [condition];
      children.forEach (child => {
        const inCondition = (selected)? selected.filter(
            item => (Array.isArray(item.value)?item.value.indexOf(child.IRI.value)>=0:item.value==child.IRI.value)
          ).length>0: false;
        if (isChecked == inCondition)
          conditions.push(makeConceptCondition(child, IRI))
      });
      if (onChange) 
        onChange(e.target.checked, conditions);
        return;
      }
    if (onChange) onChange(e.target.checked, condition);
    
  };

  render() {
    const {loading, statistics} = this.state
    //expand = флаг - открыть всё по-умолчанию
    const {IRI, content, lang, selected, expand, hideStatistics, view, hasCheck} = this.props;
    const headers = (!loading && content && content.schema)? subsetByLang(content.schema, lang, "label"):[];
    const hasConcepts = !loading && content && content.concepts;
    const allConcepts = hasConcepts ? contentToConcepts(content, lang):[];
    const header = (Array.isArray(headers)&&(headers.length>0))? headers[0].label.value: IRI;
    //Если есть связь skos:broader то использовать свёртывание уровней
    const hasBroader = (hasConcepts && content.broader)? Object.keys(content.broader).length>0:false;
    const concepts = conceptsForShow(allConcepts, loading, statistics, hasBroader);
    //console.log(this); //console.log(this, concepts); //console.log(loading); console.log(JSON.stringify(content));
    //Формируем отображение название схемы и список элементов в схеме
    return (
      <Collapse defaultActiveKey={expand?['1']:[]} onChange={callback}>
        <Panel header={header} key="1" onClick={(e) => e.stopPropagation()}>
            {loading && <LoadingComponent />}
            {concepts.map((concept, i)=> {
                const isChecked = hasChecked(view, concept, selected, hasCheck);
                return (
                  <div key={concept.IRI.value} style={{"marginBottom": "1rem"}}>
                    { 
                    (Array.isArray(concept.collapse) && concept.collapse.length>0) ?
                      CollapseGroup (view, concept, concept.collapse, selected, hasCheck, (e, concept) => this.onChangeConcept(e, concept, concept.collapse), expand, hideStatistics)
                    : 
                      <Checkbox checked={isChecked} onChange={(e) => this.onChangeConcept(e, concept)}>
                        {concept.Label.value}&nbsp;{!hideStatistics &&<ConceptCount IRI={concept.IRI.value} waitStatistics />}
                      </Checkbox>
                    }
                  </div>
                )
              })
            }
            {(!loading && (concepts.length==0)) && <p>Нет связанных концептов.</p>}
        </Panel>
      </Collapse>
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux
  const {vadms, vset} = state;
  const {lang, graph, schema, IRI} = props;
  const rIRI = (IRI)?IRI: (schema && schema.IRI)? schema.IRI.value: "IRI схемы не задан";
  const content = (schema)?[schema]:(vadms.taxonomy)? vadms.taxonomy.filter(item => item.IRI.value==IRI):[];
  const statistics = (vadms && vadms.statistics)?vadms.statistics:{};
  return {
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      IRI: rIRI,
      content: (Array.isArray(content)&& content.length>0)? content[0]: undefined,
      rfilter: vadms.rfilter,
      selected: vadms.conditions,
      statistics
  };
}

export default connect(mapStateToProps,
  dispatch => ({
    onLoadTaxonomy(scheme){
      return dispatch(AdmsRepository.loadTaxonomy(scheme));
    },
  })    
)(ConceptScheme);